import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CookieService } from 'ngx-shared-services';
import { ApiProductResponse, ApiProgramResponse, mapApiProduct, mapApiProgram } from '../../models/program-api-response.model';
import { ApiResponse } from '../../models/api-response.model';
import { Product } from '../../models/program.model';
import { ApiEndpointsService } from './api-endpoints.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProgramService {
  readonly endPointService = inject(ApiEndpointsService);
  readonly http = inject(HttpClient);
  private readonly cookieService = inject(CookieService);

  private get locale(): string {
    return this.cookieService.getI18NLocale() || environment.defaults.locale;
  }

  getPrograms() {
    const url = `${this.endPointService.baseUrl}/admin/programs?application=ATLAS`;
    return firstValueFrom(this.http.get<ApiResponse<ApiProgramResponse[]>>(url, { withCredentials: true })).then(res =>
      res.data.map(item => mapApiProgram(item, this.locale))
    );
  }

  getProductsByProgram(programId: string): Promise<Product[]> {
    const url = `${this.endPointService.baseUrl}/admin/programs/${encodeURIComponent(programId)}/products?status=ACTIVE`;
    return firstValueFrom(this.http.get<ApiResponse<ApiProductResponse[]>>(url, { withCredentials: true })).then(res =>
      res.data.map(item => mapApiProduct(item, this.locale))
    );
  }
}
